import React from 'react';
import { CertificationMark } from '../branding/CertificationMark';

export const LogoFooter: React.FC = ({ children }) => {
  return (
    <>
      <div style={{ flexGrow: 1 }} />
      <div className="d-flex align-items-center p-1 bg-dark text-light position-relative gap-2">
        <CertificationMark variant="light" style={{ height: '3em' }} />

        {children}

        <div className="tiny font-light opacity-50 position-absolute bottom-0 end-0 p-1">
          Font made by <a href="https://github.com/itfoundry/Poppins">itfoundry</a> licenced with{' '}
          <a href="https://github.com/itfoundry/Poppins/blob/master/OFL.txt">SIL OFL 1.1</a>
        </div>
      </div>
    </>
  );
};

export const GetInTouchFooter: React.FC = () => {
  return (
    <LogoFooter>
      <span>
        Having trouble? <a href="https://www.carboncrop.com/contact">Get in touch</a>
      </span>
    </LogoFooter>
  );
};
